import React, { useState } from "react";
import Navbar from "../components/Navbar";
import ReportsTable from "./components/ReportsTable";

export default function SettingsReports(props) {
 
  return (
    <div className="min-h-full bg-gray-50">
      <div className="pb-20">
        <Navbar props={props} />

      </div>

      {/* Основной контент */}
      <main className="">
        <div className="mx-auto container max-w-screen-2xl px-4 pb-12">
            <ReportsTable props={props} />
        </div>
      </main>
    </div>
  );
}
